import { render, staticRenderFns } from "./DasherTeamVerified.vue?vue&type=template&id=02115997&scoped=true"
import script from "./DasherTeamVerified.vue?vue&type=script&lang=js"
export * from "./DasherTeamVerified.vue?vue&type=script&lang=js"
import style0 from "./DasherTeamVerified.vue?vue&type=style&index=0&id=02115997&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02115997",
  null
  
)

export default component.exports